import type { RefObject } from 'react';
import type { PopupState, Token } from '../../types';

interface Props {
  popup: PopupState;
  popupRef: RefObject<HTMLDivElement | null>;
  onSave: (token: Token) => void;
  onMouseLeave: (e: React.MouseEvent) => void;
}

export default function WordPopup({ popup, popupRef, onSave, onMouseLeave }: Props) {
  const clampedLeft = Math.max(8, Math.min(popup.left, window.innerWidth - 260));

  return (
    <div
      className="fixed z-[9999] bg-slate-800 text-slate-100 rounded-xl px-4 py-3 min-w-[220px] max-w-[min(340px,calc(100vw-16px))] shadow-2xl"
      ref={popupRef}
      style={{ left: clampedLeft, bottom: popup.bottom }}
      onMouseLeave={onMouseLeave}
    >
      <div className="text-lg font-bold mb-0.5">
        {popup.token.surface}
        {popup.token.basicForm !== popup.token.surface && (
          <span className="text-sm font-normal text-slate-400 ml-1">({popup.token.basicForm})</span>
        )}
      </div>
      <div className="text-sm text-primary-400 mb-1.5">{popup.token.reading}</div>
      <div className="text-sm text-slate-300 leading-relaxed mb-2">{popup.token.translation}</div>
      <button
        className="px-3 py-1 bg-primary-600 hover:bg-primary-700 text-white text-xs rounded-md transition-colors"
        onClick={() => onSave(popup.token)}
      >
        + Save to Deck
      </button>
    </div>
  );
}
